import React from "react";
import "./App.css";

function TermsOfPositionInformation(params) {
  window.document.title = '사고링크:위치정보 이용약관'
  return (
    <>
      <div class="Wrapper">
        <div class="largeTitle">
          <strong>위치정보 이용약관</strong>
        </div>
        <br />
        <br />

        <div class="subtitle">
          <strong>제 1조 (목적)</strong>
        </div>
        <br />
        <div class="text">
          이 약관은 주식회사 사고링크 (이하 “회사”라 합니다.)가 제공하는
          위치정보사업 또는 위치기반서비스사업과 관련하여 회사와
          개인위치정보주체와의 권리, 의무 및 책임사항, 기타 필요한 사항을
          규정함을 목적으로 합니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 2조 (이용약관의 효력 및 변경)</strong>
        </div>
        <br />
        <div class="text">
          ① 본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에
          동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로 등록함으로써
          효력이 발생합니다.
          <br />
          ② 회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본
          약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한
          것으로 봅니다.
          <br />
          ③ 회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법,
          전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의
          규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할
          수 있습니다.
          <br />
          ④ 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의
          적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 10일 전부터
          적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게
          불리한 경우에는 그 적용일자 30일 전부터 적용일 이후 상당한 기간 동안
          각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편,
          SMS 등)로 약관 개정 사실을 발송하여 고지합니다.
          <br />
          ⑤ 회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지ᆞ고지일로부터
          개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 이용약관에
          승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은
          이용계약을 해지할 수 있습니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 3조 (관계법령의 적용)</strong>
        </div>
        <br />
        <div class="text">
          이 약관에 명시되지 않은 사항은 위치정보의 보호 및 이용 등에 관한 법률,
          정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전기통신기본법,
          전기통신사업법 등 관계법령과 회사의 이용약관 및 개인정보취급방침,
          회사가 별도로 정한 지침 등에 의합니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 4조 (서비스 내용 및 요금)</strong>
        </div>
        <br />
        <div class="text">
          회사가 제공하는 위치기반 서비스는 아래와 같습니다.
          <table border="1" align="center">
            <th>서비스 명칭 및 내용</th>
            <th>요금</th>
            <tr align='center'>
              <td>
                * 주변 서비스 제공업체 찾기
                <br />- 현재의 위치를 기반으로 하여 주변
                의료기관, 손해사정사,차량정비소의 위치 등의 정보를
                제공하는 서비스
              </td>
              <td rowSpan="3">
                - 서비스의 이용 : 무료
                <br />
                - 서비스의 이용을 위한 데이터 통신 비용 : 회원이 가입한
                이동통신사 요금제에 따라 직접 부담
              </td>
            </tr>
            <tr align='center'>
              <td>
                * 진료 예약 및 상담 서비스
                <br />
                -고객이 직접 의료기관, 손해사정사, 차량정비소를 선택하여
                필요정보를 원격으로 전송하여 제공받는 서비스
              </td>
            </tr>
          </table>
          ① 회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료
          서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용 가능합니다.
          <br />
          ② 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한
          방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.
          <br />
          ③ 유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의
          결제 이용약관 등 관계법에 따릅니다.
          <br />
          ④ 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의
          개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.
          <br />
          ⑤ 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각
          이동통신사의 정책에 따릅니다.
          <br />
          ⑥ MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에
          따릅니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 5조 (개인위치정보주체의 권리)</strong>
        </div>
        <br />
        <div class="text">
          ① 개인위치정보주체는 개인위치정보 수집 범위 및 이용약관의 내용 중
          일부 또는 개인위치정보의 이용ᆞ제공 목적, 제공받는 자의 범위 및
          위치기반 서비스의 일부에 대하여 동의를 유보할 수 있습니다.
          <br />
          ② 개인위치정보주체는 회사에 대하여 언제든지 개인위치정보의 수집에
          대한 동의 또는 개인위치정보를 이용한 위치기반서비스 제공 및
          개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수
          있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 수집,이용,
          제공사실 확인 자료 (동의의 일부를 철회한 경우에는 철회한 부분의
          개인위치정보 및 위치정보 이용, 제공사실 확인자료에 한함) 를
          파기합니다.
          <br />
          ③ 개인위치정보주체는 회사에 대하여 언제든지 개인위치정보의 수집, 이용
          또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수
          없고 이를 위한 기술적 수단을 갖추고 있습니다.
          <br />
          1. 개인 위치정보 주체에 대한 위치정보 수집ᆞ이용ᆞ제공사실 확인자료
          <br />
          2. 개인 위치정보 주체의 개인위치정보가 위치정보의 보호 및 이용 등에 관한
          법률 또는 다른 법령의 규정에 의하여 제3자에게 제공된 이유 및 내용
          <br />
          ④ 개인위치정보주체는 회사에 대하여 아래 자료의 열람 또는 고지를
          요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수
          있습니다. 이 경우 회사는 정당한 이유 없이 요구를 거절하지 아니합니다.
          <br />
          ⑤ 개인위치정보주체는 제1항 내지 제4항의 권리행사를 고객센터(전화
          02-6225-4529 또는 홈페이지(www.sagolink.com), 어플리케이션 1:1문의)를
          통해 회사에 요구할 수 있습니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 6조 (위치정보의 보유 기간)</strong>
        </div>
        <br />
        <div class="text">
          회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여
          개인 위치정보주체에 대한 위치정보 수집ᆞ이용ᆞ제공사실 확인자료
          (위치정보를 제공받는 자, 취득경로, 이용, 제공일시 및 방법에 관한
          자료)를 위치정보시스템에 자동으로 기록하며, 1년 이상 보관합니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 7조 (서비스의 내용 변경 및 중지)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는 위치정보사업자의 정책변경 등과 같이 회사의 제반 사정 또는
          법률상의 장애 등으로 서비스를 유지할 수 없는 경우, 서비스의 전부 또는
          일부를 제한, 변경하거나 중지할 수 있습니다.
          <br />
          ② 또한 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 서비스
          내용의 변경 사항 또는 종료를 회사의 홈페이지 공지사항을 통하여
          회원들에게 통지할 수 있습니다.
          <br />
          ③ 제 1항, 제2항에 의해 서비스 내용이 변경되거나 중단되는 경우에는
          회사는 사전에 인터넷 등에 공지하거나 개인위치정보주체에게 통지합니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 8조 (서비스 이용의 제한 및 중지)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의
          서비스 이용을 제한하거나 중지시킬 수 있습니다.
          <br />
          1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우
          <br />
          2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우
          <br />
          3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우
          <br />
          4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스
          이용에 지장이 있는때
          <br />
          5. 기타 중대한 사유로 인하여 회사가 서비스 제고를 지속하는 것이 부적당하다고
          인정하는 경우
          <br />
          ② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한
          때에는 그 사유 및 제한 기간등을 회원에게 알려야 합니다.
        </div>
        <br />

        <div class="subtitle">
          <strong>제 9조 (개인위치정보 제3자 제공 및 제한)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는 회원의 동의 없이 회원의 개인 위치정보를 제3자에게 제공하지
          아니하며, 제3자 제공서비스를 제공하는 경우에는 제공받는 자 및 제공목적을
          사전에 회원에게 고지합니다.
          <br />
          ② 회사는 개인 위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는
          개인 위치정보를 수집한당해 통신 단말장치로 매회 회원에게 제공받는 자,
          제공일시 및 제공목적을 즉시 통보합니다. 단,아래 각호에 해당하는
          경우에는 회원이 미리 특정하여 지정한 통신 단말장치 또는 전자우편으로통보합니다.
          <br />
          1. 개인 위치정보를 수집한 당해 통신 단말장치가 문자, 음성 또는
          영상의 수신기능을 갖추지아니한 경우
          <br />
          2. 회원이 개인 위치정보를 수집한 당해 통신 단말장치 외의 통신
          단말장치 또는 전자우편주소 등기타 방법으로 통보할 것을 미리 요청한 경우
          <br />
          ③ 개인 위치정보 등의 이용제공의 제한 회사는 회원의 동의가 있거나
          아래 각호에 해당하는 경우를제외하고는 개인 위치정보 또는 위치정보
          수집, 이용, 제공 사실 확인자료를 본 약관에 명시하거나별도 고지한
          범위를 넘어 이용하거나 제3자에게 제공하지 않습니다.
          <br />
          1. 위치기반 서비스 제공에 따른 요금 정산 위하여 위치정보 수집,
          이용, 제공 사실 확인자료가필요한 경우
          <br />
          2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수
          없는 형태로 가공하여제공하는 경우
        </div>
        <br />

        <div class="subtitle">
          <strong>제 10조 (법정대리인의 권리)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는14세 미만의 회원에 대해서는 개인 위치정보를 이용한 위치기반
          서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해 회원과
          당해 회원의 법정대리인으로부터 동의를 받아야합니다. 이 경우
          법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.
          <br />
          ② 회사는14세 미만의 아동의 개인 위치정보 또는 위치정보 이용, 제공
          사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나
          제3자에게 제공하고자 하는 경우에는14세미만의 아동과 그 법정대리인의
          동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.
          <br />
          1. 위치정보 및 위치기반 서비스 제공에 따른 요금정산을 위하여 위치정보
          이용, 제공사실 확인자료가 필요한 경우
          <br />
          2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는
          형태로 가공하여 제공하는 경우
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 11조 (8세 이하의 아동 등의 보호의무자의 권리)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라
          한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여
          개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는
          것으로 봅니다.
          <br />
          1. 8세 이하의 아동
          <br />
          2. 금치산자
          <br />
          3. 장애인복지법 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진
          자로서 장애인고용촉진 및 직업재활법 제2조 제2호의 규정에 의한
          중증장애인에 해당하는 자(장애인복지법 제 29조의 규정에 의하여 장애인
          등록을 한 자에 한한다.)
          <br />
          ② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의
          이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에
          보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
          <br />
          ③ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에
          동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 12조 (손해배상)</strong>
        </div>
        <br />
        <div class="text">
          ① 개인위치정보주체는 회사의 위치정보의 보호 및 이용 등에 관한 법률
          제15조 내지 26조의 규정을 위반한 행위로 손해를 입은 경우에 회사에
          대하여 손해배상을 청구할 수 있습니다. 이 경우 회사는 고의 또는 과실이
          없음을 입증하지 아니하면 책임을 면할 수 없습니다.
          <br />
          ② 회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는
          회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은 고의,
          과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 13조 (면책)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여
          회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.
          <br />
          1. 천채지변 또는 이에 준하는 불가항력의 상태가 있는 경우
          <br />
          2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제 3자의
          고의적인 서비스 방해가 있는 경우
          <br />
          3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우
          <br />
          4. 제1호 내지 제3호를 제외한 기타 회사의 고의 과실이 없는 사유로 인한
          경우
          <br />
          ② 회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성
          등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의 손해에
          대하여는 책임을 부담하지 아니합니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 14조 (분쟁의 조정)</strong>
        </div>
        <br />
        <div class="text">
          ① 회사는 위치정보와 관련된 분쟁에 대하여 개인위치정보주체와 협의가
          이루어지지 아니하거나 협의를 할 수 없는 경우에는 방송통신위원회에
          재정을 신청할 수 있습니다.
          <br />
          ② 회사 또는 개인위치정보주체는 위치정보와 관련된 분쟁에 대해 당사자간
          협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는
          개인정보보호법에 따라 개인정보분쟁조정위원회에 조정을 신청할 수
          있습니다.
          <br />
        </div>
        <br />

        <div class="subtitle">
          <strong>제 15조 (사업자 정보)</strong>
        </div>
        <br />
        <div class="text">
          회사의 상호, 주소, 전화번호 그 밖의 연락처는 다음과 같습니다.
          <br />
          <br />
          상호: (주)사고링크
          <br />
          주소: 서울특별시 관악구 낙성대로2, 지하1층(봉천동,낙성벤처창업센터)
          <br />
          전화번호: (02)6225-4529
          <br />
          이메일 주소 : contact@sagolink.com
          <br />
        </div>
        <br />

        <div class="largeTitle">
          <strong>부칙</strong>
        </div>
        <br />

        <div class="subtitle">
          <strong>제 1조 (시행일)</strong>
        </div>
        <br />
        <div class="text">본 약관은 2020년 5월 14일부터 적용됩니다.</div>
        <br />
        <br />

        <div class="subtitle">
          <strong>제 2 조 위치정보관리 책임자 정보</strong>
        </div>
        <br />
        <div class="text">
          회사는 다음과 같이 위치정보 관리책임자를 지정하여 이용자들이 서비스
          이용과정에서 발생한 민원사항 처리를 비롯하여 개인위치정보주체의 권리
          보호를 위해 힘쓰고 있습니다.
          <br />
          <br />
          위치정보 관리책임자 (개인정보 관리책임자 겸직)
          <br />
          직위 : 팀장
          <br />
          성명 : 이범주
          <br />
          이메일 주소 : bumjoo@sagolink.com
          <br />
        </div>
        <br />
        <br />
      </div>
    </>
  );
}

export default TermsOfPositionInformation;
